import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import styled from 'styled-components';
const Dots = styled.div `
  --dotActiveColour: ${brand.primary.blue};
  --dotBgColour: ${brand.global.white};
  --dotSize: 12px;
  --dotActiveWidth: 8px;

  display: flex;
  align-items: center;
  gap: var(--dotSize);
`;
const Dot = styled.button `
  ${transition('background-color')};
  ${ButtonReset};

  display: block;
  position: relative;
  width: var(--dotSize);
  height: var(--dotSize);
  border-radius: 5000px;
  background-color: transparent;
  border: 1px solid var(--dotActiveColour);
  overflow: hidden;

  &::before {
    ${transition('opacity', 0.2)};

    content: '';
    position: absolute;
    inset: 0;
    height: 100%;
    width: 100%;
    background-color: var(--dotActiveColour);
    opacity: 0;
  }

  &:focus-visible {
    outline-style: solid;
    outline-offset: 2px;
    outline-color: var(--dotActiveColour);
    outline-width: 2px;
  }

  &:focus-visible,
  &:hover {
    &::before {
      opacity: 0.5;
    }
  }

  &[data-active='true'] {
    &::before {
      opacity: 1;
    }
  }
`;
export const DotsStyles = {
    Dot,
    Dots,
};
